import React, { FC, ReactNode } from 'react';
import { Box, styled } from '@mui/material';
import { Plus } from '@styled-icons/bootstrap/Plus';
import { ItemSkeleton, CardContainer, CardIllustration } from 'DesignSystem';
import ThemeButton from 'DesignSystem/Buttons/ThemeButton/ThemeButton';
import SparkImage from 'assets/img/spark.png';
import {
  EBackgroundTypes,
  EItemTypes,
  EIllustrationTypes,
} from 'DesignSystem/types/background.types';
import { EAvailableSizes } from 'DesignSystem/types/size.types';

const Spark = styled('img')(() => ({
  position: 'absolute',
  width: 60,
  height: 60,
  right: -32,
  top: -27,
}));

interface IEmptyStateCardProps {
  buttonText?: string;
  secondaryButtonText?: string;
  secondaryButtonIcon?: ReactNode;
  variant?: EItemTypes;
  title: string;
  size?: EAvailableSizes;
  background?: EBackgroundTypes;
  renderIllustration?: ReactNode;
  renderForeground?: ReactNode;
  buttonIcon?: ReactNode;
  /** @default true  */
  showSpark?: boolean;
  'data-testid'?: string;
  'data-testid-button'?: string;
  onCreateItemClick?: () => void;
  onClickSecondaryButton?: () => void;
}

const EmptyStateCard: FC<IEmptyStateCardProps> = ({
  title,
  size = EAvailableSizes.MEDIUM,
  background,
  variant,
  buttonText,
  renderForeground,
  renderIllustration,
  secondaryButtonText,
  secondaryButtonIcon,
  buttonIcon,
  showSpark = true,
  'data-testid': dataTestId = '',
  'data-testid-button': dataTestIdButton = '',
  onCreateItemClick,
  onClickSecondaryButton,
}) => {
  return (
    <CardContainer
      title={title}
      size={size}
      background={background}
      renderIllustration={renderIllustration}
      data-testid={dataTestId}
    >
      <Box pb={2} mt={2} position="relative" maxWidth="550px">
        {!!variant ? (
          variant === EItemTypes.MAP_LAYERS || variant === EItemTypes.CHAIN_MAPPING ? (
            <CardIllustration image={EIllustrationTypes[variant]} />
          ) : (
            <ItemSkeleton variant={variant} />
          )
        ) : null}
        {showSpark && <Spark src={SparkImage} />}
        {!!renderForeground && renderForeground}
      </Box>
      <Box display="flex" gap={1}>
        {onCreateItemClick && buttonText && (
          <ThemeButton
            data-testid={dataTestIdButton}
            onClick={onCreateItemClick}
            startIcon={buttonIcon ?? <Plus size={20} color="white" />}
            size="large"
          >
            {buttonText}
          </ThemeButton>
        )}
        {onClickSecondaryButton && secondaryButtonText && (
          <ThemeButton
            onClick={onClickSecondaryButton}
            startIcon={secondaryButtonIcon}
            size="large"
            color="BLUE_ICE"
          >
            {secondaryButtonText}
          </ThemeButton>
        )}
      </Box>
    </CardContainer>
  );
};

export default EmptyStateCard;
